import axios from "axios"
import { API_URLS } from "../constants/ApiUrls";

export const fetchAllThreadsFromApi = async () => {
  const response = await axios.get(API_URLS.THREADS);
  if (response.status === 200) {
    return response.data;
  }
  return []
}

export const postNewThreadToApi = async (request: any) => {
  const response = await axios.post(API_URLS.THREADS, request);
  if (response.status === 200) {
    return {
      ...response.data,
      isStreaming: true,
    };
  }
  return 0;
}

export const putNewRequestToThreadApi = async (threadId: string, request: any) => {
  const response = await axios.post(`${API_URLS.THREADS}/${threadId}`, request);
  if (response.status === 200) {
    return {
      ...response.data,
      isStreaming: true,
    };
  }
  return null;
}